import localize from 'utils/localizer'

export const createSeverityType = (severityType, statusType) => ({
  severityType,
  statusType: statusType || severityType,
})

export const createCustomSeverityTypes = (msgTypes = {}) => {
  return Object.keys(msgTypes).reduce((prev, next) => {
    return {...prev, [next]: createSeverityType(msgTypes[next])}
  }, {})
}

export const isInRange = (n, min, max) => n >= min && n <= max

export const stringToRange = (stringRange = '') => {
  const [rangeA, rangeB] = stringRange.split(',')
  return [Number(rangeA), Number(rangeB)]
}

export const setFormatTypeMsgSeverity = (severityTypeStatus, baseMessage) => ({
  type: severityTypeStatus,
  message: localize(`responseMessage.${baseMessage || severityTypeStatus}`),
})

export const getDataStatusByRanges = configRanges => status => {
  if (!configRanges) return

  const keyRange = Object.keys(configRanges).find(range => {
    const [min, max] = stringToRange(range)
    return isInRange(status, min, max)
  })

  return configRanges[keyRange]
}
